import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { DT, DS2 } from '../../theme/designTokens';

interface Props {
  to: string;
  children: ReactNode;
  variant?: 'gold' | 'ghost';
  /** Adds the shimmer-sweep animation (Landing hero primary CTA only). */
  shine?: boolean;
}

/**
 * DS2 button — Figma-exact geometry from the 1920 Landing export:
 * gold CTA 297.22×69.85 r10.27, ghost 190.35×66.81 r10.96, Roboto 500
 * 20.82px, letter-spacing 0.685px, uppercase. Distinct from the legacy
 * <Button>/<PrimaryButton> pills, which remain in use elsewhere unchanged.
 */
export function DS2Button({ to, children, variant = 'gold', shine = false }: Props) {
  const gold = variant === 'gold';
  return (
    <Link
      to={to}
      className={shine ? 'land-cta-primary' : undefined}
      style={{
        display:        'inline-flex',
        alignItems:     'center',
        justifyContent: 'center',
        boxSizing:      'border-box',
        minWidth:       gold ? 239 : 157,
        height:         gold ? 55 : 53,
        padding:        '6px 14px',
        background:     gold ? DS2.gradient.gold : '#131313',
        color:          gold ? DS2.color.textBright : DS2.color.goldOutlineText,
        border:         '0.685px solid #C9A84C',
        borderRadius:   gold ? 10.27 : 10.96,
        fontSize:       17,
        fontWeight:     500,
        fontFamily:     DS2.font.body,
        textDecoration: 'none',
        letterSpacing:  '0.56px',
        textTransform:  'uppercase',
        boxShadow:      gold ? '0px 16px 43px -16px rgba(201, 168, 76, 0.45)' : undefined,
        transition:     gold ? DT.motion.buttonTransition : DT.motion.defaultTransition,
      }}
      onMouseEnter={gold ? e => { const el = e.currentTarget; el.style.filter = DT.hover.buttonFilter; el.style.transform = DT.hover.buttonTransform; } : undefined}
      onMouseLeave={gold ? e => { const el = e.currentTarget; el.style.filter = ''; el.style.transform = ''; } : undefined}
    >
      {children}
    </Link>
  );
}
